<ng-container *ngIf=" (inputConfig$ | async) as inputConfig">
    <p-treeSelect 
    class="md:w-20rem w-full" 
    containerStyleClass="w-full" 
    [(ngModel)]="selectedNodes" 
    [options]="arhivskeOznakeArray | async" 
    placeholder="Odaberite klasifikacijsku oznaku"
    (onNodeSelect)="onNodeSelect($event)"
    (onClear)="onClear()" 
    showClear="true"
    [ngClass]="{ readonly: inputConfig.readOnly }"
    [disabled]="inputConfig.readOnly"/>
</ng-container>
